import { API_URL } from 'utils/constants/app';
import { queryStringFromDict, RequestHelper } from 'utils/helpers/RequestHelper';

const laboratoryServiceUrl = `${API_URL}/laboratory`;

const getLaboratoryInfo = laboratoryId => RequestHelper.GET(`${laboratoryServiceUrl}/${laboratoryId}`);

const getLaboratoriesInfo = () => RequestHelper.GET(`${laboratoryServiceUrl}`);

const getLaboratories = () => RequestHelper.GET(`${laboratoryServiceUrl}/laboratories`);

const getLaboratoriesNames = () => RequestHelper.GET(`${laboratoryServiceUrl}/list`);

const modifyLaboratoryInfo = (laboratoryId, newLaboratoryInfo) =>
  RequestHelper.POST(`${laboratoryServiceUrl}/${laboratoryId}`, newLaboratoryInfo);

const getLaboratoryGlobalStats = (laboratoryId, globalStatisticParams, signal) =>
  RequestHelper.POST(`${laboratoryServiceUrl}/${laboratoryId}/globalStats`, globalStatisticParams, { signal });

const getLaboratoryDocumentTypes = () => RequestHelper.GET(`${laboratoryServiceUrl}/documents/types`)

const getLaboratoryDocumentsByTypes = (laboratoryId, types, queryParams) => {
  let queryString = queryStringFromDict({ types: types.join(','), ...queryParams });
  return RequestHelper.GET(`${laboratoryServiceUrl}/${laboratoryId}/documents?${queryString}`)
}

const uploadLaboratoryDocument = (laboratoryId, formData) =>
  RequestHelper.POST_FORMDATA(`${laboratoryServiceUrl}/${laboratoryId}/documents`, formData);

const deleteLaboratoryDocument = (laboratoryId, fileId) =>
  RequestHelper.DELETE(`${laboratoryServiceUrl}/${laboratoryId}/documents/${fileId}`);

export const LaboratoryService = {
  getLaboratoryInfo,
  getLaboratoriesInfo,
  getLaboratories,
  getLaboratoryGlobalStats,
  modifyLaboratoryInfo,
  getLaboratoriesNames,
  getLaboratoryDocumentTypes,
  getLaboratoryDocumentsByTypes,
  uploadLaboratoryDocument,
  deleteLaboratoryDocument
};